import { useCallback, useState } from 'react';
import { t } from 'i18next';

import { normalizeEmail } from '@/utils/validator';

import { requestPasswordReset, type PasswordResetChannel } from '../api';
import { toErrorMessage } from '../lib/errors';

export function usePasswordReset() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  const submit = useCallback(async (email: string, channel: PasswordResetChannel = 'EMAIL') => {
    setBusy(true);
    setError(null);
    try {
      await requestPasswordReset(normalizeEmail(email), channel);
      setSent(true);
    } catch (cause) {
      setError(toErrorMessage(cause, t('We could not send the reset link.')));
    } finally {
      setBusy(false);
    }
  }, []);

  const reset = useCallback(() => {
    setSent(false);
    setError(null);
  }, []);

  return { busy, error, sent, submit, reset };
}
